
import { Sidebar } from "./Sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const DashboardLayout = ({
  children,
  userType = "admin",
  isInventoryActive = false
}: {
  children: React.ReactNode;
  userType?: "admin" | "owner";
  isInventoryActive?: boolean;
}) => {
  const isMobile = useIsMobile();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return <div className="flex min-h-screen bg-gray-100">
      {/* Overlay pour mobile */}
      {isMobile && isSidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 transition-opacity duration-300" onClick={() => setIsSidebarOpen(false)} />}

      {/* Mobile Menu Button */}
      {isMobile && <Button 
          variant="ghost" 
          size="icon" 
          className={cn(
            "fixed z-50 h-12 w-12 rounded-full bg-violet-500 hover:bg-violet-600 text-white shadow-lg",
            isSidebarOpen ? "left-[270px]" : "left-4",
            "top-4"
          )} 
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          {isSidebarOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </Button>}

      {/* Sidebar avec animation mobile */}
      <div className={cn("h-full min-h-screen", 
        isMobile ? 
          isSidebarOpen ? 
            "fixed inset-y-0 left-0 z-40 translate-x-0" 
            : "fixed inset-y-0 left-0 z-40 -translate-x-full" 
          : "relative"
      )}>
        <Sidebar userType={userType} isInventoryActive={isInventoryActive} />
      </div>

      {/* Main content */}
      <main className={cn(
        "flex-1 overflow-x-hidden overflow-y-auto transition-all duration-300", 
        isMobile ? "pl-0" : "pl-4",
        isMobile && "pt-20 px-4"
      )}>
        <div className="max-w-7xl mx-auto p-4 py-[16px] px-0">
          {children}
        </div>
      </main>
    </div>;
};
